import { render, staticRenderFns } from "./OptionsIcon.vue?vue&type=template&id=42ae5c84"
import script from "./OptionsIcon.vue?vue&type=script&lang=js"
export * from "./OptionsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports